import React from "react";
import Ranch from "../images/rewards/icon-ranch.svg";
import Drumstick from "../images/rewards/icon-drumstick.svg";
import SmallPizza from "../images/rewards/icon-pizza-plain.svg";
import Treats from "../images/rewards/icon-treats.svg";
import Sandwiches from "../images/rewards/icon-sandwich.svg";
import LargePizza from "../images/rewards/icon-pizza.svg";

export default function Grid() {
  return (
    <div className="grayBG">
      <ul className="tableUL">
        <li>
          <div>
            <img src={Ranch} alt="Ranch Icon" />
            <div>
              <span>75</span>points
            </div>
            <h3>House-Made Ranch</h3>
          </div>
        </li>

        <li>
          <div>
            <img src={Drumstick} alt="Drumstick Icon" />
            <div>
              <span>200</span>points
            </div>
            <h3>1/2 Lb. Wings</h3>
          </div>
        </li>

        <li>
          <div>
            <img src={SmallPizza} alt="Small Signature Pizza Icon" />
            <div>
              <span>400</span>points
            </div>
            <h3>Small Signature Pizza</h3>
          </div>
        </li>

        <li>
          <div>
            <img src={Treats} alt="Cinnatreats Icon" />
            <div>
              <span>150</span>points
            </div>
            <h3>Cinnatreats or Garlic Cheesy Bites</h3>
          </div>
        </li>

        <li>
          <div>
            <img src={Sandwiches} alt="Sandwich Icon" />
            <div>
              <span>250</span>points
            </div>
            <h3>Calzone</h3>
          </div>
        </li>

        <li>
          <div>
            <img src={LargePizza} alt="Large Pizza Icon" />
            <div>
              <span>600</span>points
            </div>
            <h3>Large Signature Pizza</h3>
          </div>
        </li>
      </ul>
    </div>
  );
}
